<template>
  <el-menu
    background-color="#ffffff"
    :default-active="defaultActive()"
    :collapse="false"
    mode="vertical"
  >
    <template v-for="item in routers">
      <router-link class="router-link-menu-a"
        style="display: block;"
        v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow"
        :to="item.path+'/'+item.children[0].path"
        :key="item.children[0].name"
      >
        <el-menu-item :index="item.path+'/'+item.children[0].path">
          <i :class="item.meta.icon"></i>
          <span class="menu-name">{{$t(`route.${item.meta.title}`)}}</span>
        </el-menu-item>
      </router-link>
      <el-submenu
        v-else-if="!item.hidden"
        :index="item.path"
        :key="item.path"
        popper-append-to-body
      >
        <template slot="title">
          <i :class="item.meta.icon"></i>
          <span class="menu-name">{{$t(`route.${item.meta.title}`)}}</span>
        </template>
        <template v-for="child in item.children">
          <router-link
            v-if="!child.hidden"
            :to="item.path+'/'+child.path"
            :key="child.name"
          >
            <el-menu-item
              :class="theme.sidebarColor"
              :index="item.path+'/'+child.path"
            >
              <i :class="child.meta.icon"></i>
              <span class="menu-name">{{child.hidden}}{{$t(`route.${child.meta.title}`)}}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template>
  </el-menu>
</template>
<script>
import { mapGetters } from 'vuex'
import { setUrlPath } from '@/utils/assist'
export default {
  name: 'SidebarItem',
  data() {
    return {}
  },
  props: {
    routers: {
      type: Array,
      required: true
    }
  },
  mounted() {},
  computed: {
    ...mapGetters(['theme']),
    nowTagValue: function() {
      return setUrlPath(this.$route)
    }
  },
  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    },
    /**
     * 回显刷新之前显示的选中的菜单
     */
    defaultActive() {
      return this.$route.path
    }
  }
}
</script>
<style lang="scss" scoped>
.el-menu{
        border-right: 0px;
  a{
    padding: 0px 0px 0px 0px !important;
  }
  .router-link-menu-a{
    li{
      padding-left: 10px !important;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue